import { SsMount } from 'src/js/dom/mount.js';
import { velocity } from 'src/js/lib/velocity.js';
import { throttle } from 'lodash';
import { isMobile } from 'src/js/lib/snif.js';

const opts = {
  duration: 300,
  easing: 'easeInOutCubic',
};

export class SsAccord extends SsMount {
  constructor ( elm ) {
    super( elm );
    // Clickable part
    this.btnElm = elm.querySelector( '.ss-accord-btn' );
    // Dynamic part
    this.item = new SsMount( elm.querySelector( '.ss-accord-item' ) );
    // Hidden part
    this.body = new SsMount( elm.querySelector( '.ss-accord-body' ) );
    // Event IDs
    this.clickID = throttle( this.clickLsn.bind( this ), 60 );
  }

  onClick () {
    this.btnElm.addEventListener( 'click', this.clickID );
  }

  offClick () {
    this.btnElm.removeEventListener( 'click', this.clickID );
  }

  async clickLsn () {
    this.offClick();
    if ( ! isMobile() ) {
      await this.toggle();
    }
    this.onClick();
  }

  toggle () {
    if ( this.isOpen ) {
      return this.close();
    } else {
      return this.open();
    }
  }

  open () {
    return velocity( this.item.elm, {
      props: {
        opacity: [ 1, 0 ],
        height: [ this.getHeight(), 0 ],
      },
      opts,
      cb: () => {
        this.item.$.css( 'height', 'auto' );
      }
    });
  }

  close () {
    return velocity( this.item.elm, {
      props: {
        opacity: [ 0, 1 ],
        height: 0,
      },
      opts,
    });
  }

  getHeight () {
    return this.body.$.innerHeight();
  }

  get isOpen () {
    return this.item.elm.clientHeight > 0 ? true : false;
  }
}
